module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 2
// module chunks = 0